<template>
  <el-card class="box-card full-screen">
    <div ref="pageHead" class="table-page-head">
      <el-form :inline="true" :model="queryForm">
        <el-form-item :label="$t('phone')">
          <el-input
            v-model="queryForm.phone"
            size="small"
            :placeholder="$t('phone')"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            size="small"
            @click="getList"
            :loading="isLoading"
            ><i class="el-icon-search"></i> {{ $t("query") }}</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div
      class="data-table"
      :style="{
        top: queryTableHeight,
        height: `calc(100% - ${queryTableHeight} - 70px)`
      }"
    >
      <el-table
        :data="tableData.records"
        v-loading="isLoading"
        element-loading-background="rgba(255,255,255,0.4)"
        size="mini"
        height="100%"
      >
        <el-table-column prop="id" fixed="left" :label="$t('ID')" width="50">
        </el-table-column>
        <el-table-column
          prop="transferCode"
          fixed="left"
          :label="$t('partnerApplyCode')"
          width="200"
        >
          <template slot-scope="scope">{{ scope.row.transferCode }}</template>
        </el-table-column>
        <el-table-column
          prop="transferDate"
          :label="$t('transferDatePartner')"
          width="160"
        >
          <template slot-scope="scope">{{
            $manba(scope.row.transferDate).format("ymdhms")
          }}</template>
        </el-table-column>
        <el-table-column prop="amount" :label="$t('amount')" width="180">
          <template slot-scope="scope">
            <span class="franc">₣</span>{{ scope.row.amount.formatMoney(0) }}
          </template>
        </el-table-column>
        <el-table-column prop="status" :label="$t('status')" width="160">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 0" class="text-primary">{{
              $t("checkPending")
            }}</span>
            <span v-if="scope.row.status == 1" class="text-success">{{
              $t("completeTransaction")
            }}</span>
            <span v-if="scope.row.status == 2" class="text-danger">{{
              $t("notApproved")
            }}</span>
            <span v-if="scope.row.status == 3" class="text-warning">{{
              $t("completeReversal")
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="bankName" :label="$t('bankName')" width="200">
          <template slot-scope="scope">{{ scope.row.bankName }}</template>
        </el-table-column>

        <el-table-column
          prop="bankAccount"
          :label="$t('bankAccount')"
          width="160"
        >
          <template slot-scope="scope">
            <div class="overstep-hidden">{{ scope.row.bankAccount }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="bankName2"
          :label="$t('bankName') + ' 2'"
          width="180"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.bankName2">
              {{ scope.row.bankName2 }}
            </span>
            <span v-else>
              -
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="bankName3"
          :label="$t('bankName') + ' 3'"
          width="180"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.bankName3">
              {{ scope.row.bankName3 }}
            </span>
            <span v-else>
              -
            </span>
          </template>
        </el-table-column>

        <el-table-column prop="partnerId" :label="$t('customerId')" width="160">
          <template slot-scope="scope">
            <div class="overstep-hidden">{{ scope.row.partnerId }}</div>
          </template>
        </el-table-column>

        <el-table-column
          prop="partnerName"
          :label="$t('partnerName')"
          width="160"
        >
          <template slot-scope="scope">
            <div class="overstep-hidden">{{ scope.row.partnerName }}</div>
          </template>
        </el-table-column>

        <el-table-column
          prop="partnerAccount"
          :label="$t('partnerAccount')"
          width="160"
        >
          <template slot-scope="scope">
            <div class="overstep-hidden">{{ scope.row.partnerAccount }}</div>
          </template>
        </el-table-column>

        <el-table-column prop="partnerPhone" :label="$t('phone')" width="160">
          <template slot-scope="scope">
            <div class="overstep-hidden">{{ scope.row.partnerPhone }}</div>
          </template>
        </el-table-column>

        <el-table-column
          prop="createdId"
          :label="$t('createId')"
          width="100"
        ></el-table-column>

        <el-table-column
          prop="createTime"
          :label="$t('creationTime')"
          width="200"
        >
          <template slot-scope="scope">{{
            $manba(scope.row.createTime).format("ymdhms")
          }}</template>
        </el-table-column>
        <el-table-column
          prop="partnerReason"
          :label="$t('partnerReason')"
          width="200"
        >
          <template slot-scope="scope">
            <div class="overstep-hidden">{{ scope.row.partnerReason }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="verifyUser"
          :label="$t('Admin validation') + '' + ' ID'"
          width="220"
        ></el-table-column>

        <el-table-column
          prop="verifyTime"
          :label="$t('verifyTime')"
          width="200"
        >
          <template slot-scope="scope">{{
            $manba(scope.row.verifyTime).format("ymdhms")
          }}</template>
        </el-table-column>
        <el-table-column prop="verifyRemark" :label="$t('remark')" width="220">
          <template slot-scope="scope">
            <div class="overstep-hidden">{{ scope.row.verifyRemark }}</div>
          </template>
        </el-table-column>
        <el-table-column fixed="right" :label="$t('extend')" width="210">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.status == 0"
              type="primary"
              size="mini"
              @click="openCheckApply(scope.row)"
              >{{ $t("check") }}</el-button
            >
            <el-button v-else size="mini" disabled>{{ $t("check") }}</el-button>

            <el-button
              size="mini"
              v-if="scope.row.status == 0"
              @click="editBank(scope.row)"
              type="primary"
              >{{ $t("edit") }}</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      background
      layout="total,sizes,prev,pager,next,jumper"
      :total="tableData.total || 0"
      :page-sizes="[20, 30, 50, 100, 200]"
      :page-size="pageSize"
      :current-page="currentPage"
      @size-change="setPageSzie"
      @current-change="setCurrentChange"
      @prev-click="setCurrentChange"
      @next-click="setCurrentChange"
    />

    <el-drawer
      :title="$t('editAccount')"
      :visible.sync="editBankdrawer"
      :direction="'rtl'"
      :modal="false"
      :destroy-on-close="true"
      :wrapperClosable="false"
      :size="700"
    >
      <el-form :model="partnerForm" :rules="rulesEdit" ref="partnerForm">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$t('applyCode')" prop="transferCode">
              <el-input
                size="medium"
                v-model="partnerForm.transferCode"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$t('transferDatePartner')"
              prop="transferDate"
            >
              <el-input
                size="medium"
                v-model="partnerForm.transferDate"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('amount')" prop="amount">
              <el-input
                type="text"
                size="medium"
                v-model="partnerForm.amount"
                @input="onEditAmountInput"
              ></el-input>
            </el-form-item>
          </el-col>

          <!-- multi-banks -->
          <el-col :span="24">
            <el-form-item :label="$t('bankName')" prop="bankId1">
              <div class="bank-selection">
                <div class="bank-row">
                  <el-select
                    size="medium"
                    v-model="partnerForm.bankId1"
                    filterable
                    :placeholder="$t('selectBank')"
                    style="width: 45%"
                    @change="onEditBankChange"
                  >
                    <el-option
                      v-for="item in editAvailableBanksFor(1)"
                      :key="item.id"
                      :label="
                        item.bankName +
                          ' — FCFA ' +
                          Number(item.accountAmount || 0).formatMoney(0)
                      "
                      :value="item.id"
                    />
                  </el-select>
                  <span class="bank-amount-used" v-if="partnerForm.bankId1">
                    {{ $t("used") }}: FCFA
                    {{ Number(editAmountFromBank1).formatMoney(0) }}
                  </span>
                </div>

                <div class="bank-row" v-if="editNeedsBank2">
                  <el-select
                    size="medium"
                    v-model="partnerForm.bankId2"
                    filterable
                    :placeholder="$t('selectBank')"
                    style="width: 45%"
                    @change="onEditBankChange"
                  >
                    <el-option
                      v-for="item in editAvailableBanksFor(2)"
                      :key="item.id"
                      :label="
                        item.bankName +
                          ' — FCFA ' +
                          Number(item.accountAmount || 0).formatMoney(0)
                      "
                      :value="item.id"
                    />
                  </el-select>
                  <span class="bank-amount-used" v-if="partnerForm.bankId2">
                    {{ $t("used") }}: FCFA
                    {{ Number(editAmountFromBank2).formatMoney(0) }}
                  </span>
                </div>

                <div class="bank-row" v-if="editNeedsBank3">
                  <el-select
                    size="medium"
                    v-model="partnerForm.bankId3"
                    filterable
                    :placeholder="$t('selectBank')"
                    style="width: 45%"
                    @change="onEditBankChange"
                  >
                    <el-option
                      v-for="item in editAvailableBanksFor(3)"
                      :key="item.id"
                      :label="
                        item.bankName +
                          ' — FCFA ' +
                          Number(item.accountAmount || 0).formatMoney(0)
                      "
                      :value="item.id"
                    />
                  </el-select>
                  <span class="bank-amount-used" v-if="partnerForm.bankId3">
                    {{ $t("used") }}: FCFA
                    {{ Number(editAmountFromBank3).formatMoney(0) }}
                  </span>
                </div>

                <div
                  class="bank-summary"
                  v-if="partnerForm.bankId1 && editAmountNumber"
                >
                  <span
                    :class="
                      editIsBankAmountSufficient ? 'sufficient' : 'insufficient'
                    "
                  >
                    {{ $t("total") }}: FCFA
                    {{ Number(editTotalBankAmount).formatMoney(0) }} / FCFA
                    {{ Number(editAmountNumber).formatMoney(0) }}
                    {{ editIsBankAmountSufficient ? "✅" : "❌" }}
                  </span>
                </div>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item class="bottom-button">
          <el-button
            size="medium"
            type="primary"
            @click="updateSubmit('partnerForm')"
            :loading="isloading"
            >{{ $t("submit") }}</el-button
          >
        </el-form-item>
      </el-form>
    </el-drawer>

    <!-- 锁定/解锁账户弹框 -->

    <el-drawer
      :title="$t('partnerTransferCheck')"
      :visible.sync="partnerCheck.drawer"
      :direction="'rtl'"
      :modal="false"
      :destroy-on-close="true"
      :wrapperClosable="false"
      :size="700"
    >
      <el-form :model="partnerCheckForm" :rules="rules" ref="partnerCheckForm">
        <el-row :gutter="20">
          <el-form-item prop="id" style="display: none;">
            <el-input size="medium" v-model="partnerCheckForm.id" />
          </el-form-item>
          <el-col :span="12">
            <el-form-item :label="$t('partnerName')">
              <el-input
                v-model="partnerCheck.row.partnerName"
                size="small"
                disabled
              />
            </el-form-item>
            <el-form-item :label="$t('partnerAccount')">
              <el-input
                v-model="partnerCheck.row.partnerAccount"
                size="small"
                disabled
              />
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item :label="$t('phone')">
              <el-input
                v-model="partnerCheck.row.partnerPhone"
                size="small"
                disabled
              />
            </el-form-item>
            <el-form-item :label="$t('applyCode')">
              <el-input
                v-model="partnerCheck.row.transferCode"
                size="small"
                disabled
              />
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item :label="$t('transferDatePartner')">
              <el-input
                v-model="partnerCheck.row.transferDate"
                size="small"
                disabled
              />
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item :label="$t('amount')">
              <el-input :value="checkAmountFormatted" size="small" disabled>
                <template slot="prepend">FCFA</template>
              </el-input>
            </el-form-item>
          </el-col>

          <!-- banks -->
          <el-col :span="24">
            <el-form-item :label="$t('bankName')">
              <div class="check-bank-list">
                <div
                  class="check-bank-row"
                  v-for="(b, i) in checkBankBreakdown"
                  :key="i"
                >
                  <span class="check-bank-name">{{ b.name }}</span>
                  <span class="check-bank-amount">
                    FCFA {{ Number(b.amount || 0).formatMoney(0) }}
                  </span>
                  <span
                    class="check-bank-avail"
                    :class="b.sufficient ? 'sufficient' : 'insufficient'"
                  >
                    {{ $t("available") }}: FCFA
                    {{ Number(b.available || 0).formatMoney(0) }}
                    {{ b.sufficient ? "✅" : "❌" }}
                  </span>
                </div>

                <div
                  class="bank-summary"
                  v-if="checkBankBreakdown.length && !checkAllBanksSufficient"
                >
                  <span class="insufficient">{{
                    $t("300008:not sufficient funds")
                  }}</span>
                </div>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-divider content-position="left">{{ $t("checkInfo") }}</el-divider>
          <el-form-item :label="$t('checkStatus')" prop="status">
            <el-radio v-model="partnerCheckForm.status" :label="1" border>{{
              $t("getApproved")
            }}</el-radio>
            <el-radio v-model="partnerCheckForm.status" :label="2" border>{{
              $t("notApproved")
            }}</el-radio>
            <el-radio v-model="partnerCheckForm.status" :label="3" border>{{
              $t("cancel")
            }}</el-radio>
          </el-form-item>
          <el-form-item :label="$t('checkRemark')" prop="verifyRemark">
            <el-input
              type="textarea"
              size="medium"
              v-model="partnerCheckForm.verifyRemark"
            ></el-input>
          </el-form-item>
        </el-row>
        <div class="bottom-button">
          <el-button
            v-if="!printParam"
            size="medium"
            type="primary"
            :loading="isLoading"
            :disabled="
              partnerCheckForm.status === 1 && !checkAllBanksSufficient
            "
            @click="onSubmitCheckResult('partnerCheckForm')"
            >{{ $t("submit") }}</el-button
          >
          <el-button v-else size="medium" @click="printVisible = true">{{
            $t("printrRceipt")
          }}</el-button>
        </div>
      </el-form>
    </el-drawer>

    <el-dialog
      :title="$t('printrRceipt')"
      :visible.sync="printVisible"
      width="500px"
      :modal-append-to-body="false"
      :destroy-on-close="true"
      :show-close="false"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
      <print-credentials
        :param="printParam"
        :isClosePrint.sync="printVisible"
      />
    </el-dialog>
  </el-card>
</template>
<script>
import bank from "@/api/bank";
import printCredentials from "@/components/printCredentialsDeposit";
export default {
  name: "partnerTransferCheck",
  components: {
    printCredentials
  },
  data() {
    return {
      queryForm: {},
      //table高度，动态设置
      queryTableHeight: String,
      //table显示内容
      tableData: {},
      //分页器默认参数
      pageSize: 20,
      currentPage: 1,
      //显示加载中
      isLoading: false,
      //右侧弹框
      editBankdrawer: false,
      partnerForm: { type: 1 },
      bankList: [],
      partnerCheckForm: {},

      printVisible: false,
      printParam: null,

      //addForm: { },
      partnerCheck: {
        drawer: false,
        form: {},
        row: {}
      }
    };
  },
  computed: {
    rules() {
      return {
        status: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur"
          }
        ]
      };
    },

    rulesEdit() {
      return {
        bankId1: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "change"
          },
          {
            validator: (rule, value, callback) => {
              if (!value) return callback(new Error(this.$t("requiredFields")));
              if (!this.editIsBankAmountSufficient)
                return callback(
                  new Error(this.$t("300008:not sufficient funds"))
                );
              callback();
            },
            trigger: "change"
          }
        ]
      };
    },
    loginInfo() {
      return this.$store.state.globalParameter.loginInfo;
    },

    editAmountNumber() {
      return (
        parseFloat(String(this.partnerForm.amount || "0").replace(/\s/g, "")) ||
        0
      );
    },
    editNeedsBank2() {
      if (!this.partnerForm.bankId1 || !this.editAmountNumber) return false;
      const b1 = this.getBankById(this.partnerForm.bankId1);
      return b1 ? parseFloat(b1.accountAmount) < this.editAmountNumber : false;
    },
    editNeedsBank3() {
      if (!this.editNeedsBank2 || !this.partnerForm.bankId2) return false;
      const b1 = this.getBankById(this.partnerForm.bankId1);
      const b2 = this.getBankById(this.partnerForm.bankId2);
      if (!b1 || !b2) return false;
      return (
        parseFloat(b1.accountAmount) + parseFloat(b2.accountAmount) <
        this.editAmountNumber
      );
    },
    editTotalBankAmount() {
      return [
        this.partnerForm.bankId1,
        this.partnerForm.bankId2,
        this.partnerForm.bankId3
      ]
        .map(id => this.getBankById(id))
        .filter(Boolean)
        .reduce((sum, b) => sum + parseFloat(b.accountAmount || 0), 0);
    },
    editIsBankAmountSufficient() {
      return this.editTotalBankAmount >= this.editAmountNumber;
    },
    editAmountFromBank1() {
      const b1 = this.getBankById(this.partnerForm.bankId1);
      if (!b1 || !this.editAmountNumber) return 0;
      return Math.min(parseFloat(b1.accountAmount), this.editAmountNumber);
    },
    editAmountFromBank2() {
      const b1 = this.getBankById(this.partnerForm.bankId1);
      const b2 = this.getBankById(this.partnerForm.bankId2);
      if (!b2 || !this.editAmountNumber) return 0;
      const remaining =
        this.editAmountNumber - parseFloat(b1 ? b1.accountAmount : 0);
      return Math.max(0, Math.min(parseFloat(b2.accountAmount), remaining));
    },
    editAmountFromBank3() {
      const b1 = this.getBankById(this.partnerForm.bankId1);
      const b2 = this.getBankById(this.partnerForm.bankId2);
      const b3 = this.getBankById(this.partnerForm.bankId3);
      if (!b3 || !this.editAmountNumber) return 0;
      const remaining =
        this.editAmountNumber -
        parseFloat(b1 ? b1.accountAmount : 0) -
        parseFloat(b2 ? b2.accountAmount : 0);
      return Math.max(0, Math.min(parseFloat(b3.accountAmount), remaining));
    },
    checkAmountFormatted() {
      return Number(this.partnerCheck.row.amount || 0).formatMoney(0, " ");
    },

    checkBankBreakdown() {
      const row = this.partnerCheck.row;
      if (!row || !row.bankId) return [];

      const slots = [
        {
          id: row.bankId,
          amount: row.amountBank1 != null ? row.amountBank1 : row.amount
        },
        { id: row.bankId2, amount: row.amountBank2 },
        { id: row.bankId3, amount: row.amountBank3 }
      ];

      return slots
        .filter(s => s.id && Number(s.amount || 0) > 0)
        .map(s => {
          const b = this.getBankById(s.id);
          const available = b ? Number(b.accountAmount || 0) : 0;
          const amount = Number(s.amount || 0);
          return {
            name: b ? b.bankName : "#" + s.id,
            amount,
            available,
            sufficient: available >= amount
          };
        });
    },

    checkAllBanksSufficient() {
      const list = this.checkBankBreakdown;
      return list.length > 0 && list.every(b => b.sufficient);
    }
  },
  methods: {
    /**查询列表 */
    getList() {
      let _this = this;
      _this.isLoading = true;
      bank.getPartnerPage({
        param: {
          current: _this.currentPage,
          size: _this.pageSize,
          ..._this.queryForm
        },
        success: res => {
          _this.tableData = res.data || {};
          _this.isLoading = false;
        }
      });
    },
    getBankList() {
      bank.getAllBank({
        success: res => {
          if (res.code != 200) return;
          this.bankList = res.data;
        }
      });
    },
    getBankById(id) {
      if (!id) return null;
      return this.bankList.find(b => b.id === id) || null;
    },
    editAvailableBanksFor(slot) {
      const selected = [
        slot !== 1 ? this.partnerForm.bankId1 : null,
        slot !== 2 ? this.partnerForm.bankId2 : null,
        slot !== 3 ? this.partnerForm.bankId3 : null
      ].filter(Boolean);
      return this.bankList.filter(
        b => b.status === 0 && !selected.includes(b.id)
      );
    },
    onEditAmountInput(val) {
      const raw = String(val || "").replace(/\D/g, "");
      this.partnerForm.amount = raw
        ? raw.replace(/\B(?=(\d{3})+(?!\d))/g, " ")
        : "";
      this.onEditBankChange();
    },
    onEditBankChange() {
      if (!this.editNeedsBank2) {
        this.partnerForm.bankId2 = null;
        this.partnerForm.bankId3 = null;
      }
      if (!this.editNeedsBank3) this.partnerForm.bankId3 = null;
    },

    setPageSzie(val) {
      this.pageSize = val;
      this.getList();
    },
    setCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
    editBank(data) {
      this.partnerForm = {
        id: data.id,
        transferCode: data.transferCode,
        transferDate: this.$manba(data.transferDate).format("ymdhms"),
        amount: Number(data.amount || 0).formatMoney(0, " "),
        bankId1: data.bankId || null,
        bankId2: data.bankId2 || null,
        bankId3: data.bankId3 || null
      };
      this.editBankdrawer = true;
    },

    updateSubmit(formName) {
      let _this = this;
      _this.$refs[formName].validate(valid => {
        if (!valid) return false;
        _this.isLoading = true;
        const round2 = n => Math.round((Number(n) || 0) * 100) / 100;

        bank.updatePartnerDeposit({
          param: {
            id: _this.partnerForm.id,
            amount: _this.editAmountNumber,
            bankId: _this.partnerForm.bankId1,
            bankId2: _this.partnerForm.bankId2 || null,
            bankId3: _this.partnerForm.bankId3 || null,
            amountBank1: round2(_this.editAmountFromBank1),
            amountBank2: round2(_this.editAmountFromBank2),
            amountBank3: round2(_this.editAmountFromBank3)
          },
          success: res => {
            if (res.code == 200) {
              _this.$message.success(_this.$t("operateSuccessfully"));
              _this.getList();
              _this.getBankList();
              _this.editBankdrawer = false;
            } else {
              _this.$message.warning(_this.$t(res.msg));
            }
            _this.isLoading = false;
          }
        });
      });
    },
    openCheckApply(row) {
      this.partnerCheck.row = {
        ...row,
        transferDate: this.$manba(row.transferDate).format("ymdhms")
      };
      this.partnerCheckForm = {
        id: row.id,
        phone: row.partnerPhone,
        amount: row.amount,
        partnerAccount: row.partnerAccount,
        transferCode: row.transferCode,
        status: null,
        verifyRemark: ""
      };
      this.printParam = null;
      this.partnerCheck.drawer = true;
    },
    onSubmitCheckResult(refName) {
      let _this = this;
      _this.$refs[refName].validate(valid => {
        if (!valid) return false;

        if (
          _this.partnerCheckForm.status === 1 &&
          !_this.checkAllBanksSufficient
        ) {
          _this.$message.warning(_this.$t("300008:not sufficient funds"));
          return false;
        }

        _this.isLoading = true;
        bank.updatePartnerStatus({
          param: _this.partnerCheckForm,
          success: res => {
            _this.isLoading = false;
            if (res.code == 200) {
              _this.getList();
              _this.getBankList();
              _this.partnerCheck.drawer = false;
              _this.$message.success(_this.$t("operateSuccessfully"));
              _this.$set(_this, "printParam", res.data);
              _this.$set(_this, "printVisible", true);
            } else {
              _this.$message.warning(_this.$t(res.msg));
            }
          }
        });
      });
    }
  },
  created() {},
  mounted() {
    this.getBankList();
    let queryTableHeight = this.$refs.pageHead.offsetHeight + 15;
    this.queryTableHeight = queryTableHeight + "px";
    this.getList();
  }
};
</script>

<style lang="less" scoped>
.check-bank-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.check-bank-row {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 6px 10px;
  background: #f5f7fa;
  border-radius: 4px;
}
.check-bank-name {
  flex: 1;
  font-weight: 600;
}
.check-bank-amount {
  color: #1164c4;
  font-weight: 600;
}
.check-bank-avail {
  font-size: 12px;
}
</style>
